var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { PORTAL_PERMISSION_KEY, PORTAL_TAB_ORDER, PORTAL_TAB_PERMISSION_KEYS } from './portalDetail.constants';
var toAccess = function (permission) { return ({
    view: Number(permission === null || permission === void 0 ? void 0 : permission.View) === 1,
    add: Number(permission === null || permission === void 0 ? void 0 : permission.Add) === 1,
    update: Number(permission === null || permission === void 0 ? void 0 : permission.Update) === 1,
    delete: Number(permission === null || permission === void 0 ? void 0 : permission.Delete) === 1,
}); };
var isAnyAction = function (access) { return access.view || access.add || access.update || access.delete; };
export var usePortalPermissions = function () {
    var rolePermissions = useSelector(function (store) { var _a; return ((_a = store.User.userData) === null || _a === void 0 ? void 0 : _a.RolePermissions) || []; });
    return useMemo(function () {
        var find = function (key) { return rolePermissions.find(function (permission) { return permission.PermissionKey === key; }); };
        var tabs = PORTAL_TAB_ORDER.reduce(function (accumulator, tab) {
            var access = toAccess(find(PORTAL_TAB_PERMISSION_KEYS[tab]));
            accumulator[tab] = __assign(__assign({}, access), { visible: isAnyAction(access) });
            return accumulator;
        }, {});
        return {
            portal: toAccess(find(PORTAL_PERMISSION_KEY)),
            tabs: tabs,
            visibleTabs: PORTAL_TAB_ORDER.filter(function (tab) { return tabs[tab].visible; }),
            editableTabs: PORTAL_TAB_ORDER.filter(function (tab) { return tabs[tab].visible && tabs[tab].update; }),
        };
    }, [rolePermissions]);
};
